import { DataGrid, GridRowClassNameParams } from '@mui/x-data-grid';
import { columns, MinimalCpgRetailer } from './columns';
import {
  groupRetailers,
  MAX_RETAILER_COUNT,
  sortRetailers,
} from '../../domain/retailers';
import { useFeatures } from '@utils/hooks';
import { significanceSx } from '@components/shared/significance-sx';

const STATISTICALLY_INSIGNIFICANT_CLASSNAME = 'statistically-insignificant';

export type RetailersDataGridProps = {
  retailers: MinimalCpgRetailer[];
  showHideRetailerColumn?: boolean;
};

export const RetailersDataGrid = (props: RetailersDataGridProps) => {
  const { retailers, showHideRetailerColumn } = props;
  const groupedRetailers = groupRetailers(retailers);
  const features = useFeatures();
  const excludedColumns = new Set<ReturnType<typeof columns>[number]['field']>(
    features.cpgSalesRate ? [] : (['salesRate'] as const)
  );

  const allRetailers: MinimalCpgRetailer[] = groupedRetailers.allRetailer
    ? [groupedRetailers.allRetailer]
    : [];
  const topRetailers: MinimalCpgRetailer[] = groupedRetailers.topRetailers
    .toSorted(sortRetailers)
    .slice(0, MAX_RETAILER_COUNT)
    .map((retailer, index) => ({
      ...retailer,
      ranking: index + 1,
    }));
  const otherRetailers: MinimalCpgRetailer[] = groupedRetailers.otherRetailer
    ? [groupedRetailers.otherRetailer]
    : [];

  return (
    <DataGrid
      disableRowSelectionOnClick
      hideFooter
      columns={columns(showHideRetailerColumn).filter(
        column => !excludedColumns.has(column.field)
      )}
      rows={[...allRetailers, ...topRetailers, ...otherRetailers]}
      sx={{
        height: 'auto',
        padding: '1rem',
        ...significanceSx({
          insignificantClassname: STATISTICALLY_INSIGNIFICANT_CLASSNAME,
        }),
      }}
      getRowClassName={(params: GridRowClassNameParams<MinimalCpgRetailer>) =>
        params.row.statisticallySignificant
          ? ''
          : STATISTICALLY_INSIGNIFICANT_CLASSNAME
      }
      data-testid="retailers-table"
    />
  );
};
